import { render, staticRenderFns } from "./bootDevice.vue?vue&type=template&id=378ba365&scoped=true&"
import script from "./bootDevice.vue?vue&type=script&lang=js&"
export * from "./bootDevice.vue?vue&type=script&lang=js&"
import style0 from "./bootDevice.vue?vue&type=style&index=0&id=378ba365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ba365",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378ba365')) {
      api.createRecord('378ba365', component.options)
    } else {
      api.reload('378ba365', component.options)
    }
    module.hot.accept("./bootDevice.vue?vue&type=template&id=378ba365&scoped=true&", function () {
      api.rerender('378ba365', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/bootDevice.vue"
export default component.exports